import React, { useEffect, useState } from 'react';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState(659); // 10m 59s
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60).toString().padStart(2, '0');
  const seconds = (timeLeft % 60).toString().padStart(2, '0');
  const scrollToOffer = () => {
    const offerSection = document.getElementById('offer-section');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <>
      <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap" rel="stylesheet" data-id="element-260" />
      <div onClick={scrollToOffer} className="fixed top-0 left-0 right-0 z-50 text-white shadow-md cursor-pointer select-none animate-pulse-slow" style={{
      fontFamily: "'Roboto', sans-serif",
      backgroundColor: 'rgba(192, 0, 0, 0.85)',
      backdropFilter: 'blur(8px)'
    }} data-id="element-261">
        <div className="max-w-5xl mx-auto px-4 py-2.5 text-center" data-id="element-262">
          <p className="text-xs sm:text-sm font-bold tracking-widest uppercase mb-1" data-id="element-263">
            ⚠️&nbsp; TONIGHT'S PROTOCOL &nbsp;⚠️
          </p>
          <p className="text-xs sm:text-sm leading-relaxed uppercase tracking-wide" data-id="element-264">
            SPECIAL SALE TODAY ONLY — ENDS IN{' '}
            <span className="inline-flex items-center font-mono font-bold bg-white/20 px-2 py-0.5 rounded text-xs sm:text-sm tracking-wider normal-case" style={{
            color: '#FFD700'
          }} data-id="element-265">
              ⏰ {minutes}:{seconds}
            </span>
            <span className="mx-1.5 hidden sm:inline" data-id="element-266">·</span>
            <br className="sm:hidden" data-id="element-267" />
            <span className="mt-0.5 sm:mt-0 inline-block normal-case" data-id="element-268">
              Grab the <strong data-id="element-269">'Cooling Code'</strong> &amp; stop the 3 AM bloat
              before it starts.
            </span>
          </p>
        </div>
      </div>
    </>;
}